export const DISH_VIEW_ROWS = 'rows'
export const DISH_VIEW_TILES = 'tiles'

const DISH_VIEW_KEY = 'menu-dish-list-view'

export const readDishView = () => {
  try {
    return localStorage.getItem(DISH_VIEW_KEY) === DISH_VIEW_TILES ? DISH_VIEW_TILES : DISH_VIEW_ROWS
  } catch (e) {
    return DISH_VIEW_ROWS
  }
}

export const saveDishView = value => {
  try {
    localStorage.setItem(DISH_VIEW_KEY, value)
  } catch (e) {
  }
}

const isBlank = value => value === null || value === undefined || value === ''

export const toMoney = value => (isBlank(value)
  ? '—'
  : `${new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 }).format(value)} сом`)

export const toWeight = value => (isBlank(value) ? '—' : value)

export const toDishCount = count => {
  const tail = count % 100
  const last = tail % 10

  if (tail > 10 && tail < 20) return `${count} блюд`
  if (last === 1) return `${count} блюдо`

  return `${count} ${last >= 2 && last <= 4 ? 'блюда' : 'блюд'}`
}

const comboTypes = {
  Fixed: 'готовый набор',
  Pick: 'набор с выбором',
  Build: 'собери сам',
}

export const comboTypeText = value => comboTypes[value] || 'комбо'

const modifierTypes = {
  ToAdd: 'Что добавить',
  ToRemove: 'Что убрать',
}

const modifierTypeText = value => modifierTypes[value] || value || ''

const toLimits = (min, max) => {
  if (min && max) return min === max ? `ровно ${min}` : `от ${min} до ${max}`
  if (min) return `не меньше ${min}`
  if (max) return `не больше ${max}`

  return 'без ограничений'
}

export const toModifierRules = schema => [
  `выбор: ${toLimits(schema.minCount, schema.maxCount)}`,
  schema.freeCount ? `бесплатно: ${schema.freeCount}` : null,
  schema.isChangingPrice ? 'меняет цену' : 'не меняет цену',
].filter(Boolean).join(' · ')

export const groupModifiersByType = modifiers => (modifiers || []).reduce((parts, modifier) => {
  const type = modifier.type || null
  let part = parts.find(x => x.type === type)

  if (!part) {
    part = { type, title: modifierTypeText(type), modifiers: [] }
    parts.push(part)
  }

  part.modifiers.push(modifier)

  return parts
}, [])
